<template>
	<div class="project">
		<div class="name pb-4">
			<div class="title">Name</div>
			<AppTextField class="input" outlined dense v-model="projectName" hide-details single-line :placeholder="namePlaceholder" />
		</div>
		<div>
			<div class="title">Description</div>
			<AppTextArea
				v-model="projectDescription"
				class="text-area input"
				rows="3"
				solo
				no-resize
				hide-details
				outlined
				dense
				:placeholder="descriptionPlaceholder"
			/>
		</div>
		<PrimaryButton :loading="isLoading" v-if="canChangeData" class="my-8" :disabled="!isDataChanged" @click="updateProject">
			Update
		</PrimaryButton>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { updateProject } from '@/store/modules/projects/actions';
import { projectHasPermission } from '@/store/modules/projects/getters';
import { ProjectPermissions } from '@ply-io/ply-front-shared-utilities';
export default {
	name: 'GeneralTab',
	props: {
		project: { type: Object },
	},
	components: {},
	computed: {
		...mapGetters([projectHasPermission.fullPath]),
		isDataChanged() {
			if (!this.project) {
				return false;
			}
			return this.projectName !== this.project.title || this.description !== this.project.description;
		},
		canChangeData() {
			return this[projectHasPermission.fullPath](this.project?.id, ProjectPermissions.ChangeSettings);
		},
	},
	methods: {
		...mapActions([updateProject.fullPath]),
		async updateProject() {
			const body = {
				...this.project,
				title: this.projectName,
				description: this.projectDescription || '',
			};
			try {
				this.isLoading = true;
				await this[updateProject.fullPath]({ project: body });
				this.$toast.success('Successfully updated');
			} catch (err) {
				console.log(err);
				this.$toast.error('Failed updating project');
			} finally {
				this.isLoading = false;
			}
		},
	},
	mounted() {
		this.projectName = this.project?.title;
		this.projectDescription = this.project?.description;
	},
	data: () => ({
		projectName: '',
		namePlaceholder: 'CDR Catalyst',
		projectDescription: '',
		descriptionPlaceholder: 'Features to delight prospects and supercharge SDRs, from reach-out to hand-off',
		isLoading: false,
	}),
};
</script>

<style scoped lang="scss">
.project {
	.title {
		padding-top: 12px;
		font-size: 14px !important;
	}
	.add-description {
		text-decoration: underline;
		color: #9e9e9e;
		font-size: 14px;
		cursor: pointer;
	}
}
</style>
